<template>
  <div class="bulk-modal-root">
    <transition name="modal-fade">
      <div
        v-if="localData"
        class="modern-modal__overlay"
        @click.self="close">
        <div class="modern-modal modern-modal--md">
          <header class="modern-modal__header">
            <div>
              <h3 class="modern-modal__title">Bulk Change Password</h3>
              <p class="modern-modal__subtitle">
                Apply a password reset for multiple users at once. Choose how the new password should be generated below.
              </p>
            </div>
            <button class="modern-modal__close" type="button" @click="close">
              <feather-icon icon="XIcon" svgClasses="h-5 w-5" />
            </button>
          </header>

          <section class="modern-modal__body">
            <div class="modern-modal__scroll">
              <div class="modal-stack">
                <div class="field-group field-group--stacked vs-component vs-con-input-label vs-input w-full vs-input-primary">
                  <label class="vs-input--label">Tipe</label>
                  <div class="vs-con-input">
                    <vs-select v-model="selectedType" class="w-full">
                      <vs-select-item
                        v-for="type in types"
                        :key="type.value"
                        :value="type.value"
                        :text="type.label" />
                    </vs-select>
                  </div>
                </div>

                <div v-if="selectedType === 'manual'" class="field-stack">
                  <div class="field-group field-group--stacked vs-component vs-con-input-label vs-input w-full vs-input-primary">
                    <label class="vs-input--label">Password Baru</label>
                    <div class="vs-con-input field-password">
                      <vs-input
                        data-vv-validate-on="blur"
                        v-validate="'required|min:1|max:15'"
                        :type="show_pwd ? 'text' : 'password'"
                        name="password"
                        icon="icon icon-lock"
                        icon-pack="feather"
                        v-model="password"
                        class="w-full no-icon-border" />
                      <button class="field-password__toggle" type="button" @click="show_pwd = !show_pwd">
                        <feather-icon icon="EyeIcon" v-if="show_pwd" svgClasses="h-4 w-4" />
                        <feather-icon icon="EyeOffIcon" v-else svgClasses="h-4 w-4" />
                      </button>
                    </div>
                  </div>
                  <div class="field-group field-group--stacked vs-component vs-con-input-label vs-input w-full vs-input-primary">
                    <label class="vs-input--label">Konfirmasi Password Baru</label>
                    <div class="vs-con-input field-password">
                      <vs-input
                        data-vv-validate-on="blur"
                        v-validate="'required|min:1|max:15'"
                        :type="show_pwd_confirm ? 'text' : 'password'"
                        name="password_confirm"
                        icon="icon icon-lock"
                        icon-pack="feather"
                        v-model="password_confirm"
                        class="w-full no-icon-border" />
                      <button class="field-password__toggle" type="button" @click="show_pwd_confirm = !show_pwd_confirm">
                        <feather-icon icon="EyeIcon" v-if="show_pwd_confirm" svgClasses="h-4 w-4" />
                        <feather-icon icon="EyeOffIcon" v-else svgClasses="h-4 w-4" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <footer class="modern-modal__footer">
            <vs-button
              color="danger"
              class="mr-3 mb-2 btn-load-1 vs-con-loading__container"
              @click="openConfirmation"
              :disabled="selectedType === 'manual' && (password === '' || password !== password_confirm)">
              Submit
            </vs-button>
            <vs-button color="warning" type="border" class="mb-2" @click="close">
              Cancel
            </vs-button>
          </footer>
        </div>
      </div>
    </transition>

    <transition name="modal-fade">
      <div
        v-if="confirmation"
        class="modern-modal__overlay"
        @click.self="openConfirmation">
        <div class="modern-modal modern-modal--sm">
          <header class="modern-modal__header">
            <h3 class="modern-modal__title">Konfirmasi Aksi</h3>
            <button class="modern-modal__close" type="button" @click="openConfirmation">
              <feather-icon icon="XIcon" svgClasses="h-5 w-5" />
            </button>
          </header>
          <section class="modern-modal__body modern-modal__body--compact">
            <div class="confirmation-icon">
              <svg
                width="50"
                height="50"
                viewBox="0 0 50 50"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <rect width="50" height="50" rx="25" fill="#FFD4D4" />
                <path
                  d="M25 21.25V26.25M25 31.25H25.0125M22.8625 14.825L12.275 32.5C12.0567 32.878 11.9412 33.3066 11.94 33.7432C11.9387 34.1797 12.0518 34.6089 12.268 34.9882C12.4842 35.3674 12.7959 35.6834 13.1721 35.9048C13.5483 36.1262 13.976 36.2452 14.4125 36.25H35.5875C36.024 36.2452 36.4516 36.1262 36.8278 35.9048C37.2041 35.6834 37.5158 35.3674 37.7319 34.9882C37.9481 34.6089 38.0612 34.1797 38.06 33.7432C38.0588 33.3066 37.9433 32.878 37.725 32.5L27.1375 14.825C26.9146 14.4576 26.6009 14.1539 26.2265 13.9431C25.8521 13.7323 25.4296 13.6216 25 13.6216C24.5703 13.6216 24.1479 13.7323 23.7735 13.9431C23.3991 14.1539 23.0853 14.4576 22.8625 14.825Z"
                  stroke="#FF3939"
                  stroke-opacity="0.8"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </div>
            <h4 class="modal-confirmation__title">
              Apakah Anda yakin untuk mengganti kata sandi secara massal?
            </h4>
            <p v-if="selectedType === 'auto'" class="modal-confirmation__body">
              Kata sandi semua akun akan terganti pada
              <b>tanggal 1 pada bulan berikutnya.</b>
              Kata sandi akan diatur ulang dengan 8-16 karakter acak dan dikirim melalui email aktif setiap pengguna.
            </p>
            <p v-else class="modal-confirmation__body">
              Kata sandi semua akun akan terganti pada
              <b>tanggal 1 pada bulan berikutnya.</b>
              Kata sandi akan diganti menggunakan kata sandi yang Anda input untuk seluruh pengguna.
            </p>
          </section>
          <footer class="modern-modal__footer">
            <vs-button
              class="mr-3 mb-2"
              color="dark"
              type="border"
              @click="openConfirmation">
              Batalkan
            </vs-button>
            <vs-button
              color="danger"
              class="mr-3 mb-2 btn-load-2 vs-con-loading__container"
              @click="handleSubmit"
              :disabled="countdownConfirm > 0">
              Update
              <span v-if="countdownConfirm > 0">({{ countdownConfirm }})</span>
            </vs-button>
          </footer>
        </div>
      </div>
    </transition>
  </div>
</template>


<script>
import * as REPO from '../../repository/index'
import * as moment from 'moment'

export default {
  props: {
    openModal: Boolean,
    // data: Object,
  },
  data() {
    return {
      baseMap: 'openstreetmap',
      otpInput: '',
      types: [
        {
          label:
            'Random (8-16 karakter secara acak dengan huruf besar dan kecil dan bebeda setiap user)',
          value: 'auto',
        },
        {
          label: 'Manual Input (Input password secara manual untuk semua user)',
          value: 'manual',
        },
      ],
      confirmation: false,
      countdownConfirm: 5,
      selectedType: 'auto',
      show_pwd: false,
      password: '',
      show_pwd_confirm: false,
      password_confirm: '',
    }
  },
  computed: {
    localData: {
      get() {
        let isOpen = false
        if (typeof this.openModal === 'string') {
          const normalized = this.openModal.trim().toLowerCase()
          if (normalized === 'true' || normalized === 'false') {
            isOpen = normalized === 'true'
          } else {
            try {
              isOpen = JSON.parse(this.openModal)
            } catch (e) {
              isOpen = !!this.openModal
            }
          }
        } else {
          isOpen = !!this.openModal
        }

        if (isOpen) {
          this.password = ''
          this.password_confirm = ''
          this.show_pwd = false
          this.show_pwd_confirm = false
          this.selectedType = 'auto'
          this.confirmation = false
          this.countdownConfirm = 5
        }

        return isOpen
      },
      set(val) {
        if (!val) {
          this.$emit('closeModal')
        }
      },
    },
  },
  // for testing pupose
  // watch: {
  //   selectedDuration(val) {
  //
  //   },
  // },
  methods: {
    close() {
      this.confirmation = false
      this.$emit('closeModal', false)
    },
    openConfirmation() {
      this.confirmation = !this.confirmation

      if (this.confirmation) {
        this.countdownConfirm = 5
        const interval = setInterval(() => {
          this.countdownConfirm--
          if (this.countdownConfirm === 0) {
            clearInterval(interval)
          }
        }, 1000)
      } else {
        this.countdownConfirm = 5
      }
    },
    handleSubmit() {
      const body = {
        type: this.selectedType,
        password: this.password,
      }

      REPO.updatePassBulk(body)
        .then((res) => {
          this.$vs.notify({
            title:
              'Berhasil! Kata sandi akan diubah pada tanggal 1 pada bulan berikutnya',
            text: '',
            color: 'success',
          })
          this.$emit('closeModal', false)
        })
        .catch((err) => {
          this.$vs.notify({
            title: 'Gagal mengubah kata sandi! Silahkan coba lagi',
            text: '',
            color: 'danger',
          })
        })
    },
  },
}
</script>

<style>
#content-area.content-area-default .bulk-modal-root .modern-modal__overlay {
  left: 260px;
}

#content-area.content-area-reduced .bulk-modal-root .modern-modal__overlay {
  left: 80px;
}

#content-area.content-area-full .bulk-modal-root .modern-modal__overlay,
#content-area:not(.content-area-default):not(.content-area-reduced) .bulk-modal-root .modern-modal__overlay {
  left: 0;
}

@media (max-width: 768px) {
  #content-area .bulk-modal-root .modern-modal__overlay {
    left: 0 !important;
    right: 0;
  }
}
</style>

<style scoped>
.bulk-modal-root {
  display: contents;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
  transform: scale(0.98);
}

.modern-modal__overlay {
  position: fixed;
  top: 64px;
  left: 260px;
  right: 0;
  bottom: 0;
  background: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(3px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px;
  z-index: 2147483647;
  overflow-y: auto;
}

.modern-modal {
  width: min(520px, 92vw);
  max-height: 80vh;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 28px 70px rgba(15, 23, 42, 0.25);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.modern-modal--md {
  width: min(560px, 94vw);
}

.modern-modal__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 24px 28px 16px;
  border-bottom: 1px solid #e2e8f0;
  gap: 16px;
}

.modern-modal__title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #0f172a;
  letter-spacing: -0.01em;
}

.modern-modal__subtitle {
  margin: 6px 0 0;
  font-size: 0.85rem;
  line-height: 1.5;
  color: #64748b;
}

.modern-modal__close {
  background: transparent;
  border: none;
  border-radius: 9999px;
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease;
}

.modern-modal__close:hover {
  background: rgba(148, 163, 184, 0.25);
}

.modern-modal__body {
  padding: 20px 28px;
  overflow: hidden;
}

.modern-modal__body--compact {
  padding-bottom: 8px;
}

.modern-modal__scroll {
  max-height: calc(80vh - 160px);
  overflow-y: auto;
  padding-right: 6px;
}

.modern-modal__scroll::-webkit-scrollbar {
  width: 6px;
}

.modern-modal__scroll::-webkit-scrollbar-thumb {
  background: rgba(148, 163, 184, 0.6);
  border-radius: 9999px;
}

.modern-modal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 18px 28px 24px;
  border-top: 1px solid #e2e8f0;
  flex-wrap: wrap;
}

.modal-stack {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.field-stack {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.field-group {
  background: rgba(241, 245, 249, 0.65);
  border-radius: 14px;
  padding: 18px 18px 12px;
  border: 1px solid rgba(203, 213, 225, 0.6);
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
}

.field-group--stacked {
  white-space: normal;
}

.field-group:hover {
  border-color: rgba(148, 163, 184, 0.8);
}

.field-group:focus-within {
  border-color: #2563eb;
  background: #ffffff;
  box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.12);
}

.field-group .vs-input--label {
  font-weight: 600;
  color: #0f172a;
  margin-bottom: 8px;
}

.field-group .vs-con-input {
  border-radius: 12px;
  border: 1px solid #d0d5dd;
  background: #ffffff;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.field-group .vs-con-input:focus-within {
  border-color: #2563eb;
  box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.12);
}

.field-group ::v-deep(.vs__dropdown-toggle) {
  border-radius: 12px;
  border: 1px solid #d0d5dd;
  padding: 6px 14px;
  min-height: 44px;
  background-color: #ffffff;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.field-group ::v-deep(.vs__dropdown-toggle:focus),
.field-group ::v-deep(.vs__dropdown-toggle.vs__dropdown-toggle--focus) {
  border-color: #2563eb;
  box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.12);
}

.field-group ::v-deep(.vs__dropdown-menu) {
  border-radius: 12px;
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.15);
  margin-top: 6px;
}

.field-group ::v-deep(.vs__search) {
  padding: 0;
  margin: 0;
}

.field-password {
  position: relative;
  padding-right: 40px;
}

.field-password__toggle {
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #64748b;
}

.field-password__toggle:focus {
  outline: none;
}

.modern-modal ::v-deep(.vs-button) {
  min-height: 44px;
  padding: 0 22px;
  border-radius: 10px;
  font-weight: 600;
}

.confirmation-icon {
  display: flex;
  justify-content: center;
}

.modal-confirmation__title {
  margin: 14px 0 10px;
  font-size: 1.05rem;
  font-weight: 600;
  color: #1f2937;
  text-align: center;
}

.modal-confirmation__body {
  font-size: 0.9rem;
  line-height: 1.5;
  color: #475569;
  text-align: center;
}

@media (max-width: 640px) {
  .modern-modal__header,
  .modern-modal__body,
  .modern-modal__footer {
    padding-left: 20px;
    padding-right: 20px;
  }

  .modern-modal {
    width: min(520px, 94vw);
  }
}
</style>
